/*
====================================================
AI Product Builder Config

负责:
- UI展示规则
- 营销展示价格
- option value 映射
- addon展示信息

不负责:
- Shopify variant price
- variant id
- inventory
- selected state
====================================================
*/

window.AI_PRODUCT_BUILDER_CONFIG =
window.AI_PRODUCT_BUILDER_CONFIG || {};

(function(){

const _registry = {


//====================================================
// SIZE TEMPLATE
// 正方形 Canvas
//====================================================

size:{
display:"cards",

values:{
"8x8":{
title:"Canvas Print Small",
sizeLabel:'8" × 8"',
icon:"🖼️",
badge:"",
displayPrice:"39.00",
comparePrice:"79.00",
addons:{
frame:{
text:"Frame selected +$20.00"
}
}
},

"10x10":{
title:"Canvas Print Small",
sizeLabel:'10" × 10"',
icon:"🖼️",
badge:"",
displayPrice:"49.00",
comparePrice:"109.00",
addons:{
frame:{
text:"Frame selected +$30.00"
}
}
},


"12x12":{
title:"Canvas Print Small",
sizeLabel:'12" × 12"',
icon:"🖼️",
badge:"",
displayPrice:"59.00",
comparePrice:"119.00",
addons:{
frame:{
text:"Frame selected +$30.00"
}
}
},


"16x16":{
title:"Canvas Print Medium",
sizeLabel:'16" × 16"',
icon:"🖼️",
badge:"",
displayPrice:"79.00",
comparePrice:"159.00",
addons:{
frame:{
text:"Frame selected +$40.00"
}
}
},


"20x20":{
title:"Canvas Print Large",
sizeLabel:'20" × 20"',
icon:"🖼️",
badge:"Most Popular",
displayPrice:"99.00",
comparePrice:"199.00",
addons:{
frame:{
text:"Frame selected +$40.00"
}
}
},


"24x24":{
title:"Canvas Print XL",
sizeLabel:'24" × 24"',
icon:"🖼️",
badge:"",
displayPrice:"169.00",
comparePrice:"299.00",
addons:{
frame:{
text:"Frame selected +$50.00"
}
}
},


"32x32":{
title:"Canvas Print Royal",
sizeLabel:'32" × 32"',
icon:"👑",
badge:"Premium",
displayPrice:"279.00",
comparePrice:"449.00",
addons:{
frame:{
text:"Frame selected +$60.00"
}
}
}

}

},



//====================================================
// SIZE LANDSCAPE TEMPLATE
// 横版 Canvas 3:2
//
// Shopify Variant:
// 18x12
// 24x16
// 30x20
// 36x24
//====================================================

sizeLandscape:{
display:"cards",

values:{


"18x12":{
title:"Canvas Print Large",
sizeLabel:'18" × 12"',
icon:"🖼️",
badge:"",
displayPrice:"89.00",
comparePrice:"129.00",
addons:{
frame:{
text:"Frame selected +$40.00"
}
}
},


"24x16":{
title:"Canvas Print XL",
sizeLabel:'24" × 16"',
icon:"🖼️",
badge:"Most Popular",
displayPrice:"139.00",
comparePrice:"199.00",
addons:{
frame:{
text:"Frame selected +$50.00"
}
}
},


"30x20":{
title:"Canvas Print Grand",
sizeLabel:'30" × 20"',
icon:"👑",
badge:"Premium",
displayPrice:"179.00",
comparePrice:"269.00",
addons:{
frame:{
text:"Frame selected +$60.00"
}
}
},


"36x24":{
title:"Canvas Print Royal",
sizeLabel:'36" × 24"',
icon:"👑",
badge:"Museum Size",
displayPrice:"229.00",
comparePrice:"349.00",
addons:{
frame:{
text:"Frame selected +$70.00"
}
}
}

}

},



//====================================================
// FRAME TEMPLATE
//====================================================

frame:{
display:"swatches",

values:{

"black":{
title:"Black",
color:"#2d2d2d",
icon:""
},

"white":{
title:"White",
color:"#ffffff",
icon:""
},

"espresso":{
title:"Espresso",
color:"#4b3621",
icon:""
}

}

},



//====================================================
// COLOR TEMPLATE
//====================================================

color:{
display:"swatches",

values:{

"black":{
title:"Black",
color:"#000000"
},

"white":{
title:"White",
color:"#ffffff"
}

}

},



//====================================================
// ADDONS
//====================================================

addons:{
display:"summary",

values:{

frame:{
title:"Floating Frame"
},

giftBox:{
title:"Gift Box"
}

}

}


};



//====================================================
// CACHE
//====================================================

const _cache=new Map();



window.AI_PRODUCT_BUILDER_CONFIG.get=function(configKey){

if(_cache.has(configKey)){
return _cache.get(configKey);
}


if(!_registry[configKey]){

console.error(
`[AI Product Builder Config Error] "${configKey}" not found`
);

return null;

}


const config=_registry[configKey];

_cache.set(configKey,config);

return config;

};



})();